import FactoryComponents from '../../../../factory/components/FactoryComponents.js';
import RoleManager from '../../../components/home/manager/RoleManager.vue';
import HomeLeft from "@/components/components/home/process/comps/AsideComponent/HomeLeft.vue"
const root = {}
export default root
root.name='companyManager';
root.components = {
	HomeLeft
}
root.data = {
	
	thisName: '',
	menuDatas:[],
	defaultChooseTitle: '',
	// navIcon: ['&#xe617;','&#xe62e;','&#xe847;','&#xe623;','&#xe60e;','&#xe679;']
	navIcon: ['icon-users', 'icon-jiaoseguanli', 'icon-denglurizhi', 'icon-bumen', 'icon-shujuyuan', 'icon-gongsi'],
	leftMenus: []
};
root.methods = {
	returnHome: function(){
		this.$router.push({ path: "/home" })
	},
	routerConfig: function(menuDatas){
		const menuDatasConfig = {...menuDatas};
		console.log(menuDatas)
    menuDatasConfig.childMenu = [];
		//针对企业管理进行二级路由配置
		menuDatas.forEach((item, index)=>{
			if(item.hasAuth){
				if(item.menuName === '公司配置'){
					item.routerUri = '/companyManager/companyConfig';
				}
				if(item.menuName === '数据备份'){
					item.routerUri = '/companyManager/dataConfig';
				}
				if(item.menuName === '部门管理'){
          item.routerUri = '/companyManager/deptManager';
				}
				if(item.menuName === '登录日志'){
					item.routerUri = '/companyManager/loginLog';
				}
				if(item.menuName === '角色管理'){
					item.routerUri = '/companyManager/roleManager';
				}
				if(item.menuName === '用户管理'){
					item.routerUri = '/companyManager/userManager';
				}
				if(item.menuName === '移动端版本管理'){
					item.routerUri = '/companyManager/appVersionManager';
				}
				if(item.menuName === '系统消息设置'){
					item.routerUri = '/companyManager/systemMessageManager';
				}
        this.componentsMoudel.setData(item.routerUri, item);
        if(item.menuName !== '部门管理') {
          menuDatasConfig.childMenu.push(item);
        }
			}
			
    });
		return menuDatasConfig;
	},
};
root.mounted = function(){
	// let menuDatas = this.componentsMoudel.getData("/companyManager");
	// let menuDatas = JSON.parse(localStorage.getItem('navItem'))
	// if(menuDatas === undefined){
	// 	this.$router.push({ path: '/home' });
	// }
	// this.thisName = menuDatas.menuName;
	
	// const menuDatas2 = this.routerConfig(menuDatas);
	// this.menuDatas = menuDatas2.childMenu;
	
	// if(this.$route.path === "/companyManager"){
	// 	this.defaultChooseTitle = menuDatas2.childMenu[0].routerUri
	// 	this.$router.push({ path: this.defaultChooseTitle })
	// }else{
	// 	this.defaultChooseTitle = this.$route.path;
	// }
	this.leftMenus = JSON.parse(localStorage.getItem('navItem'))
};

FactoryComponents.initComponent(root);